import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getJobsList(queryString) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/jobs?" + queryString, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching jobs"
                    });
                }
            });
    },
    getProcessDefinitionList() {
        return axios.get(constants.BASE_URL + "/jobs/process-definitions", {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
    getJobDetail(jobId, jobType) {
        axios.defaults.withCredentials = true;
        return axios.get(constants.BASE_URL + "/jobs/" + jobId + "?jobType=" + jobType)
            .then(response => {
                return response.data;
            })
            .catch(error => {
            });
    },
    deleteJob(jobId, jobType) {
        return axios.delete(constants.BASE_URL + "/jobs/" + jobId + "?jobType=" + jobType, {
            withCredentials: true
        }).then(response => {
            return response.data;
        });
    },
}
